"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterEmptyArray = void 0;
const logger_1 = require("../logger");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
function filterEmptyArray() {
    return (0, rxjs_1.pipe)((0, operators_1.filter)((data) => {
        if (!Array.isArray(data)) {
            logger_1.logger.error('filterEmptyArray must be piped an array');
        }
        return data.length > 0;
    }));
}
exports.filterEmptyArray = filterEmptyArray;
//# sourceMappingURL=filter_empty_array.js.map